import { actionTypes } from './OfficeSplitViewActions'
import { officeHeaderHeight } from './OfficeSectionSubcomponents'

export const panelKeys = {
  pmPanel: 'pmPanel',
  officePanel: 'officePanel',
}

export const initialState = {
  [panelKeys.pmPanel]: {
    show: true,
    name: 'PM Panel',
    direction: -1,
    id: panelKeys.pmPanel,
    minSize: officeHeaderHeight,
    maxSize: Number.MAX_VALUE,
  },
  [panelKeys.officePanel]: {
    show: false,
    name: 'Office Panel',
    direction: -1,
    id: panelKeys.officePanel,
    minSize: officeHeaderHeight,
    maxSize: Number.MAX_VALUE,
  },
}

const updatePanel = (state, panelKey, isShown) => {
  const panel = state[panelKey]
  panel.show = isShown
  // To block panel
  //const initialMinSize = initialState[panelKey].minSize
  //const initialMaxSize = initialState[panelKey].maxSize
  //panel.minSize = initialMinSize
  //panel.maxSize = isShown ? initialMaxSize : initialMinSize
  return { ...state, ...{ [panelKey]: panel } }
}

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.showPanel:
      {
        const { id } = action.payload
        state = updatePanel(state, id, true)
      }
      break
    case actionTypes.hidePanel:
      {
        const { id } = action.payload
        state = updatePanel(state, id, false)
      }
      break
    case actionTypes.togglePanel:
      {
        const { id } = action.payload
        const panel = state[id]
        state = updatePanel(state, id, !panel.show)
      }
      break
    default:
      break
  }
  return state
}
